export const StyleTemplate = `POV: 

Tone and Mood: 

Narrative Voice: 

Vocabulary and Word Choice:

Sentence Structure: 

Pacing and Rhythm: 

Dialogue: 

Descriptive Style:

Narrative Structure:

Themes and Motifs: 

Cultural and Historical Context:`;
